import React from 'react'
import constants from '../../utils/constants'

class SSOSuccess extends React.Component {
    state = {
        referrer: null,
    }
    componentDidMount() {
        setTimeout(()=>{
            window.location=constants.referralMap[this.state.referrer].path
        }, 5000)
        const search = new URLSearchParams(window.location.search)
        const referrer = search.get('referrer')
        this.setState({referrer});   
    }

    render() {
        return(
            this.state.referrer ?
                <div className='card'>
                    Successfully logged in. You will now be redirected back to {constants.referralMap[this.state.referrer].name}.
                </div> : <div className='card'>
                    No referrer found.
                </div>
            
        )
    }
}

export default SSOSuccess;